/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types'
import { ApolloProvider } from '@apollo/client'
// we check later
import { client } from '../utils/apollo-client-wrapper'
import StitchingLayer from '../components/stitchingLayer/stitchingLayer'
import restClient from '../utils/apollo-client-wrapper/apollo-rest-client-wrapper'
import { LoaderContextProvider } from './LoaderContext'

const Provider = ({ children, isRestAPI }) => (
  <ApolloProvider client={isRestAPI ? restClient : client}>
    <>
      <LoaderContextProvider>
        <StitchingLayer>{children}</StitchingLayer>
      </LoaderContextProvider>
    </>
  </ApolloProvider>
)

Provider.propTypes = {
  children: PropTypes.PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.array,
    PropTypes.object,
    PropTypes.node
  ]).isRequired,
  isRestAPI: PropTypes.bool.isRequired
}

export default Provider
